import { FC } from 'react';

import { TextField } from '@shared/components/TextField';
import { Control, UseFormRegister, useWatch } from 'react-hook-form';

interface IProps {
  register: UseFormRegister<any>;
  control: Control<any, any>;
  names: {
    receiverName: string;
    receiverAddress: string;
  };
}

// 수령지는 "도로명주소, [장례식장명, 호실]"로 시딩됨 — 보는 사람에게 중요한 빈소 정보를 첫 줄에 강조
const parseReceiverAddress = (address: string) => {
  const match = /^(.*),\s*\[(.+)\]\s*$/.exec(address);
  const place = match?.[2];
  if (place) {
    return { place, street: match?.[1] ?? '' };
  }
  return { place: address, street: '' };
};

const ReceiverInfoInputs: FC<IProps> = ({
  register,
  control,
  names: { receiverName, receiverAddress },
}: IProps) => {
  const receiverAddressValue = useWatch({
    control,
    name: receiverAddress,
    defaultValue: '',
  });
  const { place, street } = parseReceiverAddress(String(receiverAddressValue ?? ''));

  return (
    <div className="font-bold">
      <h4>수령하실 분</h4>
      <div className="pt-3">
        <TextField
          scrollOnFocus={true}
          className="w-full"
          placeholder="수령인 성함"
          {...register(receiverName, { required: true })}
        />
        {/* 주소는 부고 정보로 확정된 값이라 고객 화면에선 표기만 — 오기입 교정은 판매자/관리자 도구로 처리 */}
        <div className="pl-2 pt-2.5">
          <p className="break-keep leading-[22px]">
            <span className="text-sm font-bold theme-text-1">{place}</span>
            {street && (
              <span className="pl-1.5 text-xs font-normal theme-text-8">{street}</span>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReceiverInfoInputs;
